export default __webpack_public_path__ + "static/yael-weiss-ba56543c76503dd6e64a5f111db5d0ab.svg";